import clsx from 'clsx';
import Icon from './Icon';

interface ConnectionStatusProps {
  isConnected: boolean;
  className?: string;
}

export default function ConnectionStatus({ isConnected, className }: ConnectionStatusProps) {
  return (
    <div className={clsx('flex items-center gap-2', className)}>
      <Icon 
        name={isConnected ? 'wifi' : 'wifi_off'} 
        size="small"
        className={clsx(
          isConnected ? 'text-green-500' : 'text-red-500 animate-pulse'
        )}
      />
      <span className={clsx(
        'text-xs font-medium',
        isConnected ? 'text-green-600' : 'text-red-600'
      )}>
        {isConnected ? 'Live' : 'Connecting...'}
      </span>
    </div>
  );
}
